module.exports = __webpack_public_path__ + "img/noSavedJobs.99359d52.svg";